import { PaletteOptions, darken, lighten } from '@mui/material/styles';

// HiPay colors
const performanceViolet = '#2C0A64';
const confidenceBlue = '#6864E7';
const cheerfulOrange = '#FF8C50';
const securityGray = '#E6E6F4';

const primary = '#A50979';
const secondary = confidenceBlue;
const success = '#02A17B';
const error = '#CB2B0B';
const warning = cheerfulOrange;
const info = performanceViolet;
const grey = '#20272B';

const textPrimary = '#20272B';
const textSecondary = '#4D5255';

const palette: PaletteOptions = {
  primary: {
    light: lighten(primary, 0.3),
    main: primary,
    dark: darken(primary, 0.3),
    contrastText: '#FFFFFF'
  },
  secondary: {
    light: lighten(secondary, 0.3),
    main: secondary,
    dark: darken(secondary, 0.3),
    contrastText: '#FFFFFF'
  },
  success: {
    light: lighten(success, 0.3),
    main: success,
    dark: darken(success, 0.3),
    contrastText: '#FFFFFF'
  },
  error: {
    light: lighten(error, 0.3),
    main: error,
    dark: darken(error, 0.3),
    contrastText: '#FFFFFF'
  },
  warning: {
    light: lighten(warning, 0.3),
    main: warning,
    dark: darken(warning, 0.3),
    contrastText: textPrimary
  },
  neutral: {
    light: lighten(grey, 0.6),
    main: lighten(grey, 0.3),
    dark: grey,
    contrastText: '#FFFFFF'
  },
  info: {
    light: lighten(info, 0.3),
    main: info,
    dark: darken(info, 0.3),
    contrastText: '#FFFFFF'
  },
  light: {
    main: securityGray,
    contrastText: performanceViolet
  },
  darkBackground: {
    main: '#FFF'
  },
  lookup: {
    main: lighten(secondary, 0.7)
  },
  // The colors used to style the action elements.
  action: {
    // // The color of an active action like an icon button.
    active: '#2C0A64',
    // The color of a hovered action.
    hover: '#20272B14', // 0.04 default
    hoverOpacity: 0.08, // 0.04 default
    // The color of a selected action.
    selected: '#20272B1F', // rgba(0, 0, 0, 0.08) default
    // // The color of a disabled action.
    disabled: '#20272B66',
    // // The background color of a disabled action.
    disabledBackground: '#E4E5E6'
  },
  input: {
    background: 'rgba(32, 39, 43, 0.06)',
    bottomLine: 'rgba(32, 39, 43, 0.2)',
    disabled: 'rgba(32, 39, 43, 0.12)'
  },
  global: {
    background1: '#FFFFFF',
    background2: '#F8F9FB',
    background3: '#FFFFFF'
  },
  local: {
    background1: '#F8F9FB',
    background2: '#F5F5F5',
    background3: '#FFFFFF'
  },
  background1: '#F8F9FB',
  background2: '#F5F5F5',
  background3: '#FFFFFF',
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: textPrimary,
    // Secondary text.
    secondary: textSecondary,
    // Disabled text have even lower visual prominence.
    disabled: '#A6A9AA',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: '#D9D9DB',
  grey: {
    50: lighten(grey, 0.95),
    100: lighten(grey, 0.9),
    200: lighten(grey, 0.8),
    300: lighten(grey, 0.7),
    400: lighten(grey, 0.6),
    500: lighten(grey, 0.5),
    600: lighten(grey, 0.4),
    700: lighten(grey, 0.3),
    800: lighten(grey, 0.2),
    900: lighten(grey, 0.1),
    A100: '#B1B3B5',
    A200: '#9B9EA0',
    A400: '#63686B',
    A700: '#41474B'
  }
};

export default palette;
